module.exports = __webpack_public_path__ + "static/media/nurse_accredited5.33aa613a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse_accredited5.png
// module id = 484
// module chunks = 0